import React from "react";
import { Link } from "gatsby";

const Menu = ({ active }) => (
  <div className="column feature-menu">
    <ul className="features-tabs">
      <li className="nav-item">
        <Link className={`nav-link ${active === "txn" ? "active" : ""}`} data-toggle="tab" to="/products/apm/features">
          TRANSACTIONS
        </Link>
      </li>
      <li className="nav-item">
        <Link className={`nav-link ${active === "jvm" ? "active" : ""}`} data-toggle="tab" to="/products/apm/features/jvmstats">
          JVM STATS
        </Link>
      </li>
      <li className="nav-item">
        <Link className={`nav-link ${active === "alerts" ? "active" : ""}`} data-toggle="tab" to="/products/apm/features/alerts">
          ALERTS
        </Link>
      </li>
      <li className="nav-item">
        <Link className={`nav-link ${active === "errors" ? "active" : ""}`} data-toggle="tab" to="/products/apm/features/errors">
          ERRORS
        </Link>
      </li>
      <li className="nav-item">
        <Link className={`nav-link ${active === "reports" ? "active" : ""}`} data-toggle="tab" to="/products/apm/features/reports">
          REPORTS
        </Link>
      </li>
    </ul>
  </div>
);

export default Menu;
